<canvas *ngIf="!isPublic" #appIcon class="app__image"></canvas>
<img *ngIf="isPublic" class="app__image" alt="" [src]="publicImageSrc" (error)="handleMissingImage()">
